import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ma-auto" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center mb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 mx-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "ma-0",
        align: "center",
        style: _normalizeStyle('min-height: 100vh; background:url(/files/login-' + _ctx.$vuetify.theme.name + '.png); background-repeat: no-repeat; background-size: cover;')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_row, { class: "ma-0 mb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  src: '/files/logo-' + _ctx.$vuetify.theme.name + '.png',
                  width: "80px",
                  class: "mb-2"
                }, null, 8, _hoisted_2),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              class: "pa-12 pt-8 pb-8",
              elevation: "8",
              rounded: "lg",
              "max-width": "600"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_card_title, { class: "px-0" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("¿Olvidaste tu contraseña?")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, {
                    class: "px-0",
                    style: {"white-space":"normal"}
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Ingresa el correo electrónico asociado a tu cuenta y te enviaremos instrucciones para restablecerla.")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_v_form, {
                  onSubmit: _withModifiers(_ctx.recoverPassword, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      variant: "underlined",
                      label: "Email"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      color: "primary",
                      block: "",
                      style: {"text-transform":"none"}
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Recuperar Contraseña")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onSubmit"]),
                _createVNode(_component_v_card_subtitle, {
                  class: "mt-6",
                  style: {"text-align":"center"}
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("a", {
                      class: "text-decoration-none",
                      href: "/login",
                      rel: "noopener noreferrer"
                    }, "Iniciar Sesión", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}